import { isRouteErrorResponse, useRouteError } from "react-router";

import { PageHeader } from "../components/shell/AppShell";
import { ErrorState } from "../components/ui/Feedback";
import { ApiError } from "../lib/api";

export function RouteErrorPage() {
  const error = useRouteError();
  const requestId = error instanceof ApiError ? error.problem.requestId : undefined;
  const status = isRouteErrorResponse(error) ? error.status : undefined;
  return (
    <div className="page">
      <PageHeader title="Sayfa açılamadı" />
      {status === 403 ? (
        <p>
          Bu işlem için yetkiniz yok. Erişim gerekiyorsa bir owner veya yöneticiyle iletişime geçin.
        </p>
      ) : (
        <ErrorState requestId={requestId} />
      )}
    </div>
  );
}
